/**
 * 收付款明细打印配置
 * 字段与打印模板 BILL_CONFIGS.MONEY_DETAIL 绑定
 */

import { getLoginName } from '@/utils/util'

export const BILL_TYPE = 'MONEY_DETAIL'
export const REPORT_TITLE = '收付款明细'

// 表格列定义
export const defColumns = [
  {
    title: '序号', dataIndex: 'rowIndex', width: 60, align: 'center',
    customRender: function (t, r, index) {
      return (t !== '合计') ? (parseInt(index) + 1) : t
    }
  },
  { title: '单据编号', dataIndex: 'billNo', width: 140, ellipsis: true, scopedSlots: { customRender: 'billNoCustomRender' } },
  { title: '往来单位', dataIndex: 'organName', width: 120, ellipsis: true },
  { title: '财务人员', dataIndex: 'handsPersonName', width: 100, ellipsis: true },
  { title: '操作员', dataIndex: 'userName', width: 100, ellipsis: true },
  { title: '账户信息', dataIndex: 'accountName', width: 100, ellipsis: true },
  { title: '单据类别', dataIndex: 'type', width: 80, align: 'center' },
  { title: '采购或销售单号', dataIndex: 'billNumber', width: 140, ellipsis: true, scopedSlots: { customRender: 'billNumberCustomRender' } },
  {
    title: '原欠款', dataIndex: 'needDebt', width: 100, align: 'right',
    customRender: function (t) { return t != null ? parseFloat(t).toFixed(2) : '' }
  },
  {
    title: '收款', dataIndex: 'moneyInAmount', width: 100, align: 'right',
    customRender: function (t) { return t != null ? parseFloat(t).toFixed(2) : '' }
  },
  {
    title: '付款', dataIndex: 'moneyOutAmount', width: 100, align: 'right',
    customRender: function (t) { return t != null ? parseFloat(t).toFixed(2) : '' }
  },
  { title: '单据日期', dataIndex: 'billTimeStr', width: 100, align: 'center' },
  { title: '备注', dataIndex: 'remark', width: 150, ellipsis: true }
]

// 打印数据构建 - 将列表数据 + 查询条件映射为打印字段
export function buildPrintData(dataSource, queryParam, userInfo, companyInfo) {
  // 步骤1：从 dataSource 末尾提取合计行
  const totalRow = (dataSource || []).find(item => item.rowIndex === '合计')
  const totalMoneyIn = totalRow ? Number(totalRow.moneyInAmount || 0) : 0
  const totalMoneyOut = totalRow ? Number(totalRow.moneyOutAmount || 0) : 0
  const totalNeedDebt = totalRow ? Number(totalRow.needDebt || 0) : 0

  // 步骤2：过滤合计行，映射数据行
  const rows = (dataSource || [])
    .filter(item => item.rowIndex !== '合计')
    .map((item, idx) => ({
      rowIndex: idx + 1,
      billNo: item.billNo || '',
      organName: item.organName || '',
      handsPersonName: item.handsPersonName || '',
      userName: item.userName || '',
      accountName: item.accountName || '',
      type: item.type || '',
      billNumber: item.billNumber || '',
      needDebt: item.needDebt || 0,
      moneyInAmount: item.moneyInAmount || 0,
      moneyOutAmount: item.moneyOutAmount || 0,
      billTimeStr: item.billTimeStr || '',
      remark: item.remark || ''
    }))

  // 步骤3：追加合计行到表格末尾
  if (totalRow) {
    rows.push({
      rowIndex: '合计',
      billNo: '',
      organName: '',
      handsPersonName: '',
      userName: '',
      accountName: '',
      type: '',
      billNumber: '',
      needDebt: totalNeedDebt,
      moneyInAmount: totalMoneyIn,
      moneyOutAmount: totalMoneyOut,
      billTimeStr: '',
      remark: ''
    })
  }

  return {
    // 单据主体
    reportTitle: REPORT_TITLE,
    reportDate: new Date().toLocaleDateString(),
    dateRange: (queryParam && queryParam.beginTime && queryParam.endTime)
      ? queryParam.beginTime + ' ~ ' + queryParam.endTime : '',
    creatorName: getLoginName(),
    totalMoneyIn: totalMoneyIn,
    totalMoneyOut: totalMoneyOut,
    // 单据明细
    table: rows,
    // 公司信息 / 其它信息
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || '',
    companyFax: (companyInfo && companyInfo.companyFax) || ''
  }
}